import {type UpmPlantsContextValue} from '@hconnect/upm'

export type ImportPlantOption = {
  upmId: string
  plantId: string
  siteName: string
}

export const buildImportPlantOptions = (
  upmIds: string[],
  upmPlants?: UpmPlantsContextValue,
  fallbackName?: (upmId: string) => string
): ImportPlantOption[] => {
  const safeUpmPlants = upmPlants ?? {}
  const byUpmId = new Map(Object.values(safeUpmPlants).map((plant) => [plant.upmId, plant]))
  const resolveFallback = fallbackName ?? ((id: string) => `Plant: ${id}`)

  return upmIds
    .filter((id, index, allIds) => allIds.indexOf(id) === index)
    .map((upmId) => {
      const plant = byUpmId.get(upmId)
      return {
        upmId,
        plantId: plant?.plantId ?? upmId,
        siteName: plant?.name ?? resolveFallback(upmId)
      }
    })
    .sort((left, right) => left.siteName.localeCompare(right.siteName))
}

export const resolveSiteNameForPlant = (upmId: string, options: ImportPlantOption[]): string => {
  return options.find((option) => option.upmId === upmId)?.siteName ?? ''
}

export const isValidPlantForImport = (upmId: string, options: ImportPlantOption[]): boolean => {
  return options.some((option) => option.upmId === upmId)
}
